<!--
 * @Description: 维修工单详情
-->
<template>
  <scroll-layout class="repair-detail-page">
    <template slot="header">
      <div class="detail-header card">
        <div class="header-left">
          <el-button type="text" class="back-btn" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            返回列表
          </el-button>
          <div class="header-title-row" style="margin-top: 8px">
            <h2 class="header-title">维修工单详情</h2>
            <span class="status-tag" :class="getStatusClass(detail.status)">
              {{ detail.statusText || '--' }}
            </span>
          </div>
          <p class="header-order-no">工单编号：{{ detail.orderNo || '--' }}</p>
        </div>
        <div class="header-actions">
          <el-button
            v-if="
              detail.platform !== 2 &&
              detail.stationType === 2 &&
              detail.orderType === 2 &&
              detail.status !== 40 &&
              detail.status !== 50
            "
            type="warning"
            size="small"
            @click="handleReplace">
            <i class="el-icon-sort"></i>
            换桩
          </el-button>
          <el-button
            v-if="detail.status === 10 || detail.status === 20"
            type="primary"
            size="small"
            @click="handleAddRecord">
            <i class="el-icon-plus"></i>
            添加维修记录
          </el-button>
          <el-button
            v-if="detail.status === 10 || detail.status === 20"
            type="success"
            size="small"
            @click="handleComplete">
            <i class="el-icon-check"></i>
            完成工单
          </el-button>
          <el-button
            v-if="detail.status === 40"
            type="primary"
            size="small"
            @click="handleAddRemark">
            <i class="el-icon-plus"></i>
            添加维修备注
          </el-button>
          <el-button
            v-if="detail.status === 10 || detail.status === 20 || detail.status === 40"
            type="plain"
            size="small"
            @click="handleToggleMark">
            <i class="el-icon-star-off"></i>
            {{ detail.markStatus === 1 ? '取消标记' : '标记' }}
          </el-button>
          <el-button
            v-if="detail.status === 10 || detail.status === 20"
            type="danger"
            size="small"
            @click="handleCancel">
            <i class="el-icon-close"></i>
            作废工单
          </el-button>
        </div>
      </div>
    </template>

    <!-- 主体内容：左右布局 -->
    <div class="detail-body" v-loading="loading">
      <!-- 左侧区域 (2/3) -->
      <div class="detail-main">
        <!-- 工单流程 -->
        <div class="card section">
          <h3 class="section-title">
            <i class="el-icon-s-operation title-icon"></i>
            工单流程
          </h3>
          <div class="timeline">
            <div class="timeline-item" v-for="(step, index) in flowSteps" :key="index">
              <div class="timeline-dot" :class="step.active ? 'active' : step.done ? 'done' : ''">
                <i :class="step.icon"></i>
              </div>
              <div
                class="timeline-line"
                v-if="index < flowSteps.length - 1"
                :class="{ done: step.done }"></div>
              <div class="timeline-content">
                <div class="timeline-header">
                  <span class="timeline-label" :class="{ active: step.active, done: step.done }">
                    {{ step.label }}
                  </span>
                  <span class="timeline-time" v-if="step.time">{{ step.time }}</span>
                </div>
                <p class="timeline-desc" v-if="step.desc">{{ step.desc }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 基础信息 -->
        <div class="card section">
          <h3 class="section-title">
            <i class="el-icon-info title-icon"></i>
            基础信息
          </h3>
          <div class="info-grid">
            <div class="info-row">
              <span class="info-label">工单编号</span>
              <span class="info-value">{{ detail.orderNo || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">工单状态</span>
              <span class="info-value">
                <span class="status-tag" :class="getStatusClass(detail.status)">
                  {{ detail.statusText || '--' }}
                </span>
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">工单类型</span>
              <span class="info-value">{{ detail.orderTypeText || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">所属平台</span>
              <span class="info-value">{{ detail.platformText || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">故障等级</span>
              <span class="info-value">{{ detail.faultLevelText || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">标记状态</span>
              <span class="info-value">{{ detail.markStatusText || '未标记' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">电站名称</span>
              <span class="info-value">{{ detail.stationName || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">所属城市</span>
              <span class="info-value">{{ detail.cityName || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">电站地址</span>
              <span class="info-value">
                {{ detail.stationAddress || '--' }}
                <a v-if="detail.stationAddress" class="nav-link" @click="handleNavigate">
                  <i class="el-icon-location"></i>
                  导航
                </a>
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">电站类型</span>
              <span class="info-value">
                <span
                  class="type-tag"
                  :class="detail.stationType === 2 ? 'type-private' : 'type-public'">
                  {{ detail.stationTypeText || '--' }}
                </span>
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">设备编号</span>
              <span class="info-value">{{ detail.deviceNo || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">设备品牌</span>
              <span class="info-value">{{ detail.brand || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">设备型号</span>
              <span class="info-value">{{ detail.pileTypeText || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">车位号</span>
              <span class="info-value">{{ detail.parkingNo || '--' }}</span>
            </div>
          </div>
        </div>

        <!-- 故障信息 -->
        <div class="card section">
          <h3 class="section-title warning-title">
            <i class="el-icon-warning title-icon"></i>
            故障信息
          </h3>
          <div class="info-rows">
            <div class="info-row">
              <span class="info-label">故障分类</span>
              <span class="info-value">{{ detail.faultCategory || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">故障事项</span>
              <span class="info-value">{{ detail.faultItem || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">故障描述</span>
              <span class="info-value fault-desc">{{ detail.faultDesc || '暂无故障描述' }}</span>
            </div>
            <div class="info-row" v-if="detail.faultImages && detail.faultImages.length">
              <span class="info-label">故障图片</span>
              <span class="info-value">
                <div class="image-list">
                  <img
                    v-for="(img, index) in detail.faultImages"
                    :key="index"
                    :src="img"
                    class="fault-image"
                    @click="previewImage(img)" />
                </div>
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">创建人</span>
              <span class="info-value">{{ detail.creatorName || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">创建时间</span>
              <span class="info-value">{{ detail.createTime || '--' }}</span>
            </div>
          </div>
        </div>

        <!-- 维修记录 -->
        <div class="card section" v-if="detail.repairRecords && detail.repairRecords.length">
          <h3 class="section-title">
            <i class="el-icon-document-copy title-icon"></i>
            维修记录
          </h3>
          <div class="record-list">
            <div class="record-card" v-for="(record, index) in detail.repairRecords" :key="index">
              <div class="record-header">
                <span class="record-title">{{ getRecordTitle(index) }}</span>
                <span class="record-time">{{ record.operateTime }}</span>
              </div>
              <p class="record-content">{{ record.content }}</p>
              <!-- 换桩信息展示 -->
              <div class="replace-info" v-if="record.newPileCode && record.oldPileCode">
                <span class="replace-tag old">旧桩：{{ record.oldPileCode }}</span>
                <i class="el-icon-right replace-arrow"></i>
                <span class="replace-tag new">新桩：{{ record.newPileCode }}</span>
              </div>
              <div class="record-meta">
                <span v-if="record.operator">
                  <i class="el-icon-user"></i>
                  处理人：{{ record.operator }}
                </span>
                <span v-if="record.nextRepairDate">
                  <i class="el-icon-date"></i>
                  下次维修时间：{{ record.nextRepairDate }}
                </span>
                <span v-if="record.preparation">
                  <i class="el-icon-s-order"></i>
                  准备工作：{{ record.preparation }}
                </span>
              </div>
              <!-- 维修记录图片 -->
              <div class="record-images" v-if="record.photoUrls && record.photoUrls.length">
                <div class="image-label">维修图片：</div>
                <div class="image-list">
                  <img
                    v-for="(img, imgIndex) in record.photoUrls"
                    :key="imgIndex"
                    :src="img"
                    class="record-image"
                    @click="previewImage(img)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-sidebar">
        <!-- 负责人信息 -->
        <div class="card section">
          <h3 class="section-title">
            <i class="el-icon-user title-icon"></i>
            负责人信息
          </h3>
          <div class="person-info">
            <div class="person-avatar">
              {{ (detail.assigneeName || '--').substring(0, 1) }}
            </div>
            <div class="person-detail">
              <p class="person-name">{{ detail.assigneeName || '--' }}</p>
              <p class="person-role">运维专员</p>
              <p class="person-area" v-if="detail.cityName">负责区域：{{ detail.cityName }}</p>
            </div>
          </div>
        </div>

        <!-- 时间信息 -->
        <div class="card section">
          <h3 class="section-title">
            <i class="el-icon-time title-icon"></i>
            时间信息
          </h3>
          <div class="time-info">
            <div class="time-row">
              <span class="time-label">创建时间</span>
              <span class="time-value">{{ detail.createTime || '--' }}</span>
            </div>
            <div class="time-row" v-if="detail.repairRecords && detail.repairRecords.length">
              <span class="time-label">首次处理</span>
              <span class="time-value">{{ detail.repairRecords[0].operateTime || '--' }}</span>
            </div>
            <div class="time-row" v-if="duration">
              <span class="time-label">持续时间</span>
              <span class="time-value duration">{{ duration }}</span>
            </div>
            <div class="time-row" v-if="detail.finishTime">
              <span class="time-label">完成时间</span>
              <span class="time-value">{{ detail.finishTime }}</span>
            </div>
            <div class="time-row" v-if="detail.cancelTime">
              <span class="time-label">作废时间</span>
              <span class="time-value">{{ detail.cancelTime }}</span>
            </div>
          </div>
        </div>

        <!-- 操作日志 -->
        <div class="card section">
          <h3 class="section-title">
            <i class="el-icon-document title-icon"></i>
            操作日志
          </h3>
          <div class="log-list">
            <div class="log-item" v-for="(log, index) in operationLogs" :key="index">
              <span class="log-time">{{ log.time }}</span>
              <span class="log-content">{{ log.content }}</span>
            </div>
            <div class="log-empty" v-if="!operationLogs.length">暂无操作日志</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加维修记录弹窗 -->
    <el-dialog
      title="添加维修记录"
      :visible.sync="showRecordDialog"
      width="480px"
      :close-on-click-modal="false"
      @close="onRecordDialogClose">
      <AddRecord
        v-if="showRecordDialog"
        ref="addRecord"
        :orderInfo="{ id: orderId }"
        @success="handleRecordSuccess" />
      <span slot="footer">
        <el-button size="small" @click="showRecordDialog = false">取消</el-button>
        <el-button type="primary" size="small" @click="submitRecord">确认</el-button>
      </span>
    </el-dialog>

    <!-- 完成/添加维修备注弹窗 -->
    <el-dialog
      :title="completeOrRemarkMode === 'complete' ? '完成工单' : '添加维修备注'"
      :visible.sync="showCompleteOrRemarkDialog"
      width="480px"
      :close-on-click-modal="false"
      @close="onCompleteOrRemarkClose">
      <CompleteOrRemark
        v-if="showCompleteOrRemarkDialog"
        ref="completeOrRemark"
        :mode="completeOrRemarkMode"
        :orderInfo="{ id: orderId, orderNo: detail.orderNo }"
        @success="handleCompleteOrRemarkSuccess" />
      <span slot="footer">
        <el-button size="small" @click="showCompleteOrRemarkDialog = false">取消</el-button>
        <el-button type="primary" size="small" @click="submitCompleteOrRemark">确认</el-button>
      </span>
    </el-dialog>

    <!-- 作废工单确认弹窗 -->
    <el-dialog title="" :visible.sync="showCancelDialog" width="400px" :show-close="false">
      <div class="confirm-dialog-content">
        <div class="confirm-icon danger-icon"><i class="el-icon-warning"></i></div>
        <h3 class="confirm-title">确认作废工单</h3>
        <p class="confirm-desc">确认该维修工单无效，作废后将无法恢复，是否继续？</p>
      </div>
      <span slot="footer" class="confirm-footer">
        <el-button size="small" @click="showCancelDialog = false">取消</el-button>
        <el-button type="danger" size="small" @click="confirmCancel">确认作废</el-button>
      </span>
    </el-dialog>

    <!-- 换桩弹窗 -->
    <el-dialog
      title="私桩换桩"
      :visible.sync="showReplaceDialog"
      width="500px"
      :close-on-click-modal="false">
      <div class="replace-dialog-content">
        <div class="replace-section">
          <h4 class="replace-section-title">原充电桩信息</h4>
          <div class="replace-detail-row">
            <span class="replace-label">桩编号</span>
            <span class="replace-value">{{ detail.deviceNo || '--' }}</span>
          </div>
          <div class="replace-detail-row">
            <span class="replace-label">联系人电话</span>
            <span class="replace-value">{{ detail.assigneePhone || '--' }}</span>
          </div>
        </div>
        <div class="replace-section">
          <h4 class="replace-section-title">新充电桩</h4>
          <ykc-form
            :model="replaceForm"
            :rules="replaceRules"
            ref="replaceForm"
            class="replace-form">
            <ykc-form-item label="桩编码" prop="newPileId">
              <ykc-dropdown
                :clearable="true"
                :data="newPileOptions"
                v-model="replaceForm.newPileId"
                placeholder="请选择新充电桩编码"></ykc-dropdown>
            </ykc-form-item>
          </ykc-form>
        </div>
      </div>
      <span slot="footer" class="confirm-footer">
        <el-button size="small" @click="showReplaceDialog = false">取消</el-button>
        <el-button type="warning" size="small" @click="confirmReplace" :loading="replaceLoading">
          确认换桩
        </el-button>
      </span>
    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog
      :visible.sync="imagePreviewVisible"
      :show-close="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      custom-class="image-preview-dialog"
      @click.native.native="imagePreviewVisible = false">
      <img
        :src="previewImageUrl"
        alt="图片预览"
        style="max-width: 100%; max-height: 80vh; display: block; margin: 0 auto" />
    </el-dialog>
  </scroll-layout>
</template>

<script>
  import { repairOrderApi, directPage } from '@/service/apis';
  import AddRecord from './AddRecord.vue';
  import CompleteOrRemark from './CompleteOrRemark.vue';

  export default {
    name: 'RepairOrderDetail',
    components: {
      AddRecord,
      CompleteOrRemark,
    },
    data() {
      return {
        loading: false,
        detail: {},
        showRecordDialog: false,
        showCompleteOrRemarkDialog: false,
        completeOrRemarkMode: 'complete',
        showCancelDialog: false,
        showReplaceDialog: false,
        replaceLoading: false,
        replaceForm: {
          newPileId: null,
        },
        replaceRules: {
          newPileId: [{ required: true, message: '请选择新充电桩编码', trigger: 'change' }],
        },
        newPileOptions: [],
        imagePreviewVisible: false,
        previewImageUrl: '',
      };
    },
    computed: {
      orderId() {
        return this.$route.query.id;
      },
      /** 工单流程步骤 */
      flowSteps() {
        const status = this.detail.status;
        const steps = [
          {
            label: '创建工单',
            icon: 'el-icon-document',
            done: true,
            active: false,
            time: this.detail.createTime,
            desc: this.detail.creatorName ? `创建人：${this.detail.creatorName}` : '',
          },
          {
            label: '维修处理',
            icon: 'el-icon-s-tools',
            done: status >= 20 && status !== 50,
            active: status === 20,
            time:
              this.detail.repairRecords && this.detail.repairRecords.length
                ? this.detail.repairRecords[0].operateTime
                : '',
            desc:
              this.detail.repairRecords && this.detail.repairRecords.length
                ? `处理人：${this.detail.repairRecords[0].operator || ''}`
                : '',
          },
          {
            label: '完成工单',
            icon: 'el-icon-circle-check',
            done: status === 40,
            active: false,
            time: status === 40 ? this.detail.finishTime : '',
            desc: status === 50 ? '工单已作废' : status !== 40 ? '等待操作...' : '',
          },
        ];
        return steps;
      },
      /** 持续时间 */
      duration() {
        if (!this.detail.createTime) return '';
        const start = new Date(this.detail.createTime.replace(/-/g, '/'));
        const end = this.detail.finishTime
          ? new Date(this.detail.finishTime.replace(/-/g, '/'))
          : new Date();
        const diff = end - start;
        if (diff <= 0) return '';
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        if (hours > 0) return `${hours}小时${minutes}分钟`;
        return `${minutes}分钟`;
      },
      /** 操作日志 */
      operationLogs() {
        const logs = [];
        if (this.detail.cancelTime && this.detail.status === 50) {
          logs.push({ time: this.formatTime(this.detail.cancelTime), content: '工单已作废' });
        }
        if (this.detail.finishTime && this.detail.status === 40) {
          logs.push({ time: this.formatTime(this.detail.finishTime), content: '工单已完成' });
        }
        if (this.detail.repairRecords && this.detail.repairRecords.length) {
          this.detail.repairRecords.forEach(r => {
            logs.push({
              time: this.formatTime(r.operateTime),
              content: `${r.operator || ''} 添加了维修记录`,
            });
          });
        }
        if (this.detail.createTime) {
          logs.push({
            time: this.formatTime(this.detail.createTime),
            content: `${this.detail.creatorName || ''} 创建了工单`,
          });
        }
        return logs;
      },
    },
    watch: {
      orderId: {
        immediate: true,
        handler(val) {
          if (val) {
            this.loadDetail();
          }
        },
      },
    },
    methods: {
      goBack() {
        this.$router.push({ path: '/operationManagement/repairOrder/list' });
      },
      async loadDetail() {
        this.loading = true;
        try {
          const res = await repairOrderApi.getDetail(this.orderId);
          this.detail = res || {};
        } catch (error) {
          console.error('加载详情失败', error);
        } finally {
          this.loading = false;
        }
      },
      getStatusClass(status) {
        const map = {
          10: 'status-pending',
          20: 'status-processing',
          30: 'status-transferred',
          40: 'status-completed',
          50: 'status-cancelled',
        };
        return map[status] || '';
      },
      getRecordTitle(index) {
        const num = this.detail.repairRecords ? this.detail.repairRecords.length - index : 1;
        return `第${num}次维修处理`;
      },
      formatTime(time) {
        if (!time) return '';
        // 提取 MM-DD HH:mm
        const match = time.match(/(\d{2})-(\d{2})\s+(\d{2}:\d{2})/);
        if (match) return `${match[1]}-${match[2]} ${match[3]}`;
        return time.substring(5, 16);
      },
      /** 导航 */
      handleNavigate() {
        const addr = encodeURIComponent(this.detail.stationAddress || '');
        window.open(`https://uri.amap.com/search?keyword=${addr}`, '_blank');
      },
      /** 添加维修记录 */
      handleAddRecord() {
        this.showRecordDialog = true;
      },
      onRecordDialogClose() {
        this.showRecordDialog = false;
      },
      handleRecordSuccess() {
        this.showRecordDialog = false;
        this.loadDetail();
      },
      async submitRecord() {
        const success = await this.$refs.addRecord?.submit();
        if (success) {
          this.showRecordDialog = false;
          this.loadDetail();
        }
      },
      /** 完成工单 */
      handleComplete() {
        this.completeOrRemarkMode = 'complete';
        this.showCompleteOrRemarkDialog = true;
      },
      /** 添加维修备注 */
      handleAddRemark() {
        this.completeOrRemarkMode = 'remark';
        this.showCompleteOrRemarkDialog = true;
      },
      /** 标记/取消标记 */
      async handleToggleMark() {
        const targetStatus = this.detail.markStatus === 1 ? 0 : 1;
        const actionText = targetStatus === 1 ? '标记' : '取消标记';
        try {
          await repairOrderApi.batchMark({
            orderIds: [Number(this.orderId)],
            markStatus: targetStatus,
          });
          this.$message.success(`${actionText}成功`);
          this.loadDetail();
        } catch (error) {
          console.error(`${actionText}失败`, error);
        }
      },
      async submitCompleteOrRemark() {
        const success = await this.$refs.completeOrRemark?.submit();
        if (success) {
          this.showCompleteOrRemarkDialog = false;
          this.loadDetail();
        }
      },
      handleCompleteOrRemarkSuccess() {
        this.showCompleteOrRemarkDialog = false;
        this.loadDetail();
      },
      onCompleteOrRemarkClose() {
        this.showCompleteOrRemarkDialog = false;
      },
      /** 作废工单 */
      handleCancel() {
        this.showCancelDialog = true;
      },
      async confirmCancel() {
        try {
          await repairOrderApi.cancel(this.orderId);
          this.$message.success('工单已作废');
          this.showCancelDialog = false;
          this.loadDetail();
        } catch (error) {
          console.error('作废工单失败', error);
        }
      },
      /** 换桩 */
      handleReplace() {
        this.replaceForm.newPileId = null;
        this.showReplaceDialog = true;
        this.loadNewPileOptions();
      },
      loadNewPileOptions() {
        directPage
          .queryPile({ pileCode: '' })
          .then(res => {
            this.newPileOptions = (res || []).map(item => ({
              id: item.pileId,
              name: item.pileCode,
            }));
          })
          .catch(err => {
            console.error('获取桩编码列表失败', err);
          });
      },
      confirmReplace() {
        this.$refs.replaceForm.validate(async valid => {
          if (!valid) return;
          this.replaceLoading = true;
          try {
            const data = {
              oldPileId: this.detail.pileId,
              newPileId: this.replaceForm.newPileId,
            };
            const res = await directPage.changePile(data);
            if (res) {
              // 换桩成功后，自动添加一条带换桩信息的维修记录
              try {
                const newPileOption = this.newPileOptions.find(
                  item => item.id === this.replaceForm.newPileId
                );
                await repairOrderApi.addRecord({
                  orderId: Number(this.orderId),
                  content: `换桩操作：${this.detail.deviceNo || ''} → ${
                    newPileOption ? newPileOption.name : ''
                  }`,
                  canCompleteToday: 1,
                  operatorId: localStorage.userId ? Number(localStorage.userId) : null,
                  operatorName: localStorage.accountName || '',
                  oldPileCode: this.detail.deviceNo || '',
                  newPileCode: newPileOption ? newPileOption.name : '',
                });
              } catch (recordError) {
                console.error('添加换桩维修记录失败', recordError);
              }
              this.$message.success('换桩成功');
            } else {
              this.$message.error('换桩失败');
            }
            this.replaceLoading = false;
            this.showReplaceDialog = false;
            this.loadDetail();
          } catch (error) {
            this.replaceLoading = false;
            console.error('换桩失败', error);
          }
        });
      },
      /** 图片预览 */
      previewImage(url) {
        this.previewImageUrl = url;
        this.imagePreviewVisible = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .repair-detail-page {
    background: #f5f7fa;
  }

  .card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }

  /* ==================== 顶部信息栏 ==================== */
  .detail-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .header-title-row {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    margin-right: 10px;
  }

  .header-order-no {
    font-size: 13px;
    color: #9ca3af;
    margin: 0;
  }

  .header-actions {
    display: flex;
    gap: 8px;
  }

  .back-btn {
    font-size: 14px;
    color: #6b7280;
    padding: 0;

    &:hover {
      color: #2563eb;
    }
  }

  /* ==================== 状态标签 ==================== */
  .status-tag {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .status-pending {
    background: #fef3c7;
    color: #92400e;
  }

  .status-processing {
    background: #dbeafe;
    color: #1e40af;
  }

  .status-transferred {
    background: #f3e8ff;
    color: #7c3aed;
  }

  .status-completed {
    background: #d1fae5;
    color: #065f46;
  }

  .status-cancelled {
    background: #fee2e2;
    color: #991b1b;
  }

  /* ==================== 主体布局 ==================== */
  .detail-body {
    display: flex;
    gap: 16px;
    padding: 16px;
  }

  .detail-main {
    flex: 2;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .detail-sidebar {
    flex: 1;
    min-width: 200px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  @media (max-width: 900px) {
    .detail-body {
      flex-direction: column;
    }

    .detail-sidebar {
      min-width: 100%;
    }
  }

  /* ==================== 区域标题 ==================== */
  .section-title {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 16px 0;
    display: flex;
    align-items: center;
  }

  .title-icon {
    color: #2563eb;
    margin-right: 6px;
    font-size: 16px;
  }

  .warning-title .title-icon {
    color: #f59e0b;
  }

  /* ==================== 工单流程时间线 ==================== */
  .timeline {
    position: relative;
    padding-left: 8px;
  }

  .timeline-item {
    position: relative;
    padding-left: 40px;
    padding-bottom: 24px;
  }

  .timeline-item:last-child {
    padding-bottom: 0;
  }

  .timeline-dot {
    position: absolute;
    left: 0;
    top: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #d1d5db;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    z-index: 1;
  }

  .timeline-dot.done {
    background: #3b82f6;
  }

  .timeline-dot.active {
    background: #2563eb;
  }

  .timeline-line {
    position: absolute;
    left: 13px;
    top: 28px;
    bottom: 0;
    width: 2px;
    background: #e5e7eb;
  }

  .timeline-line.done {
    background: #3b82f6;
  }

  .timeline-header {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .timeline-label {
    font-weight: 500;
    color: #9ca3af;
    font-size: 14px;
  }

  .timeline-label.active,
  .timeline-label.done {
    color: #1f2937;
  }

  .timeline-time {
    font-size: 12px;
    color: #9ca3af;
  }

  .timeline-desc {
    font-size: 13px;
    color: #6b7280;
    margin-top: 2px;
  }

  /* ==================== 信息网格 ==================== */
  .info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 32px;
  }

  .info-rows {
    display: flex;
    flex-direction: column;
  }

  .info-row {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;
    font-size: 14px;
  }

  .info-row:last-child {
    border-bottom: none;
  }

  .info-label {
    width: 80px;
    color: #6b7280;
    flex-shrink: 0;
  }

  .info-value {
    flex: 1;
    color: #1f2937;
  }

  .fault-desc {
    line-height: 1.6;
  }

  /* 导航链接 */
  .nav-link {
    color: #2563eb;
    font-size: 12px;
    cursor: pointer;
    margin-left: 8px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  /* 电站类型标签 */
  .type-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 4px;
    font-size: 12px;
  }

  .type-public {
    background: #eff6ff;
    color: #2563eb;
  }

  .type-private {
    background: #faf5ff;
    color: #7c3aed;
  }

  /* ==================== 故障图片 ==================== */
  .image-list {
    display: flex;
    gap: 8px;
    margin-top: 4px;
  }

  .fault-image {
    width: 56px;
    height: 56px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  /* ==================== 维修记录 ==================== */
  .record-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .record-card {
    padding: 14px;
    background: #f9fafb;
    border-radius: 8px;
  }

  .record-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }

  .record-title {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
  }

  .record-time {
    font-size: 12px;
    color: #9ca3af;
  }

  .record-content {
    font-size: 14px;
    color: #4b5563;
    margin-bottom: 8px;
    line-height: 1.5;
  }

  .record-meta {
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: #6b7280;

    i {
      margin-right: 2px;
    }
  }

  /* 维修记录图片 */
  .record-images {
    margin-top: 12px;

    .image-label {
      font-size: 13px;
      color: #6b7280;
      margin-bottom: 8px;
    }

    .image-list {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }

    .record-image {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 6px;
      cursor: pointer;
      border: 1px solid #e5e7eb;
      transition: all 0.2s;

      &:hover {
        opacity: 0.8;
        transform: scale(1.05);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    }
  }

  /* ==================== 右侧 - 负责人信息 ==================== */
  .person-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .person-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #2563eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    flex-shrink: 0;
  }

  .person-name {
    font-weight: 500;
    color: #1f2937;
    margin: 0;
    font-size: 14px;
  }

  .person-role,
  .person-area {
    font-size: 13px;
    color: #6b7280;
    margin: 2px 0 0 0;
  }

  /* ==================== 右侧 - 时间信息 ==================== */
  .time-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .time-row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
  }

  .time-label {
    color: #6b7280;
  }

  .time-value {
    color: #1f2937;
  }

  .time-value.duration {
    color: #f59e0b;
    font-weight: 500;
  }

  /* ==================== 右侧 - 操作日志 ==================== */
  .log-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .log-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
  }

  .log-time {
    color: #9ca3af;
    white-space: nowrap;
  }

  .log-content {
    color: #4b5563;
  }

  .log-empty {
    font-size: 13px;
    color: #9ca3af;
    text-align: center;
    padding: 8px 0;
  }

  /* ==================== 确认弹窗 ==================== */
  .confirm-dialog-content {
    text-align: center;
    padding: 10px 0;
  }

  .confirm-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    font-size: 24px;
  }

  .success-icon {
    background: #d1fae5;
    color: #10b981;
  }

  .danger-icon {
    background: #fee2e2;
    color: #ef4444;
  }

  .confirm-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 8px;
  }

  .confirm-desc {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
  }

  .confirm-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
  }

  /* ==================== 换桩信息 ==================== */
  .replace-info {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    padding: 8px 12px;
    background: #f0f9ff;
    border-radius: 6px;
    border: 1px solid #bae6fd;
  }

  .replace-tag {
    font-size: 13px;
    font-weight: 500;
    padding: 2px 8px;
    border-radius: 4px;
  }

  .replace-tag.old {
    background: #fef3c7;
    color: #92400e;
  }

  .replace-tag.new {
    background: #d1fae5;
    color: #065f46;
  }

  .replace-arrow {
    color: #9ca3af;
    font-size: 14px;
  }

  /* ==================== 换桩弹窗 ==================== */
  .replace-dialog-content {
    padding: 0 10px;
  }

  .replace-section {
    margin-bottom: 20px;
  }

  .replace-section:last-child {
    margin-bottom: 0;
  }

  .replace-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 12px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #f3f4f6;
  }

  .replace-detail-row {
    display: flex;
    align-items: center;
    padding: 6px 0;
    font-size: 14px;
  }

  .replace-form {
    padding: 0;
  }

  .replace-label {
    width: 90px;
    color: #6b7280;
    flex-shrink: 0;
  }

  .replace-value {
    color: #1f2937;
  }

  /* 图片预览弹窗 */
  .image-preview-dialog {
    .el-dialog {
      background: transparent;
      box-shadow: none;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      text-align: center;
    }
  }
</style>
